import { WrapperContent } from "../WrapperContent";

export function Footer() {
  return (
    <footer className="w-full box-border py-2">
      <WrapperContent>
        <p className="text-xs text-roboto text-secondary">
          Copyright © 2024 tuhogar.com.co
        </p>
      </WrapperContent>
    </footer>
  );
}

export default { Footer };
